import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { SelectOption } from 'global';
import { Account, LenderProfile, VendorContactRoles } from 'types';
import { reportsApi } from '../api';
import { LocationsQueryResponse } from '../api/types';

export const useLenderPerformanceFilterOptions = () => {
  const lenderProfiles = useSelector((state: any) => state.lp) as LenderProfile[];
  const account = useSelector((state: any) => state.account) as Account;

  const { data: locationsData, loading: isLocationsLoading } = useQuery<LocationsQueryResponse>(
    reportsApi.getLocations
  );

  const lenderOptions = useMemo<SelectOption[]>(
    () =>
      (lenderProfiles ?? []).map(lenderProfile => ({
        label: lenderProfile.lenderName,
        value: lenderProfile.id,
      })),
    [lenderProfiles]
  );

  const salesRepOptions = useMemo<SelectOption[]>(
    () =>
      (account?.contacts ?? [])
        .filter(contact => contact.vendorContactRole === VendorContactRoles.SalesRep)
        .map(contact => ({
          label: contact.fullName ?? '',
          value: contact.id,
        })),
    [account?.contacts]
  );

  const locationOptions = useMemo<SelectOption[]>(
    () =>
      (locationsData?.locations ?? []).map(location => ({
        label: location.locationName,
        value: location.locationId,
      })),
    [locationsData]
  );

  return { lenderOptions, salesRepOptions, locationOptions, isLocationsLoading };
};
